import { useQuery } from '@tanstack/react-query';
import { fetchTaskLocation } from '../services/api/tasks';

/**
 * MKS-144 — resolve a ticket ref (numeric id or code, e.g. MKS-144) into
 * `{ taskId, projectId }` via GET /api/tasks/:taskId/locate. `retry: false`
 * so a 403 (no access / unknown ref — the backend deliberately returns the
 * same status for both) surfaces immediately instead of retrying three
 * times behind a spinner. `staleTime` is long because a task never changes
 * project.
 */
export function useTaskLocation(ref: string) {
  return useQuery({
    queryKey: ['task-location', ref],
    queryFn: () => fetchTaskLocation(ref),
    enabled: Boolean(ref),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}
